import React from "react";
import styled from "styled-components";

import ErrorBox from "src/SharedComponents/ErrorBox";
import LoadingIndicator from "src/SharedComponents/LoadingIndicator";
import ServerSelector from "src/SharedComponents/Select/ServerSelector";

import { SessionContext } from "src/Views/SessionContext";
import { getQVeraZones, getRhapsodyHeader } from "../ramService";
import { RolesContext } from "src/Roles/RolesContext";
import IQVeraZone from "src/ServerEntities/IQVeraZone";
import IRhapsodyServer from "src/ServerEntities/IRhapsodyServer";
import Zone from './Zone';

const ContentContainer = styled.main`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
`;

const ZoneContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
`;

const Zones = () => {
    const { state, dispatch } = React.useContext(SessionContext);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState("");
    const [zones, setZones] = React.useState<IQVeraZone[]>([]);
    const [data, setData] = React.useState(undefined as unknown as IRhapsodyServer[]);
    const selectedServer = state.selectedSever || 0;

    const setSelectedServer = (index: number) => {
        dispatch({ type: "setSelectedServer", payload: index });
    };

    const roleContext = React.useContext(RolesContext);
    const currentRole = roleContext.state.role;
    const headerInfo = state.headerInfo ? state.headerInfo : data as IRhapsodyServer[];

    React.useEffect(() => {
        if (!state.headerInfo) {
            setLoading(true);
            getRhapsodyHeader(state.webToken, (serverData: IRhapsodyServer[]) => {
                setLoading(false);
                setError("");
                setData(serverData);
                dispatch({ type: "setHeaderInfo", payload: serverData });
            }, (errorMessage: string) => {
                setLoading(false);
                setError(errorMessage);
            });
        }
    }, [state.webToken, currentRole]);

    const loadServers = () => {
        if (headerInfo && headerInfo[selectedServer]) {
            setLoading(true);
            getQVeraZones(headerInfo[selectedServer].id, state.webToken, (serverData: IQVeraZone[]) => {
                setLoading(false);
                setZones(serverData);
            }, (erroMessage: string) => {
                setLoading(false);
                setError(erroMessage);
            });
        }
    };

    React.useEffect(loadServers, [state.webToken, selectedServer]);

    return (
        <ContentContainer>
            <LoadingIndicator type="Linear" show={loading} />
            {error && <ErrorBox>{error}</ErrorBox>}
            <ServerSelector headerInfo={headerInfo} selectedServer={selectedServer} setSelectedServer={setSelectedServer} />
            <ZoneContainer>
                {headerInfo && zones && zones.map((z) => {
                    return <Zone zone={z} key={`qvera-${headerInfo[selectedServer].id}-zone-${z.zoneId}`} />;
                })}
            </ZoneContainer>
        </ContentContainer>
    );
};

export default Zones;

